<div
	[ngClass]="{
		'form-group': formGroupClass && !hasSecondLine,
		'has-error': hasError() || inputError,
		'mod-verification': verificationFlowFlag
	}">
  @if (label) {
    <label class="form-label" [ngClass]="{ flex: infoTooltipUrl, inputError: inputError }">
      {{ label }}
      @if (infoTooltipUrl) {
        <a
          #infoTooltip
          class="info-tooltip-icon"
          [target]="'_blank'"
          [href]="infoTooltipUrl"
          [tabIndex]="-1">
          <span
            class="bpi__icon-info"
            bp-tooltip="{{ infoTooltipDescription ? infoTooltipDescription : '' }}"
            position="top"
            (keydown.enter)="infoTooltip.click()"
          [tabIndex]="0"></span>
        </a>
      }
    </label>
  }
  <div
    class="bp-input-field"
		[ngClass]="{
			'form-text-inside': textInside,
			wiggling: wiggle
		}">
    <ng-content select="[left]"></ng-content>
    <div
      class="bp-input-wrapper"
			[ngClass]="{
				'second-line-structure': hasSecondLine,
				'form-icon-inside': icon || iconUrl,
				'mod-leading': iconLeading,
				'form-text-inside': textInside
			}">
      <ng-content select="[right]"></ng-content>
      <!-- Not a nice solution, but if the placeholder defined in the temnplate then it will overwrites the value which comes from the bp-type even if it is null   -->

      <input
        #inputGroup
        [(ngModel)]="_value"
        [precision]="precision"
        [bp-type]="type"
        [step]="step"
        [min]="min"
        [max]="max"
        (ngModelChange)="_value = $event; inputModified($event)"
        [readonly]="readonly"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [phone-region]="phoneRegion"
        [maxlength]="maxlength"
        (keydown.enter)="onKeydownEnter()"
        [formatted-output]="formattedOutput"
        [focus]="focus"
        (focus)="onInputFocus($event)"
        [tabIndex]="0"
        (focusout)="onInputFocusOut($event)"
				[ngClass]="{
					'bp-form-field': true,
					'mod-disabled': readonly,
					'mod-transparent': transparent,
					'mod-clear-button': hcArticle,
					'bp-phone': isBpPhone,
					'placeholder-spacing': hasSecondLine || displayLogo,
					'input-style-for-second-line': hasSecondLine && _value.length > 0 && !isActive
				}" />
      <!-- Not a nice solution, but if the placeholder defined in the template then it will overwrites the value which comes from the bp-type even if it is null   -->
      @if (hasSecondLine && !isActive && _value.length > 0 && secondLine.length > 0) {
        <span class="second-line">
          {{ secondLineConcat }}
        </span>
      }
      @if (hcArticle.length > 0 || (hasSecondLine && _value.length > 0 && isActive)) {
        <span>
          @if (_value.length > 0) {
            <button
              type="button"
              class="form-search-clear-button mod-input-field"
              [ngClass]="{ 'clear-button-flag-on': hasSecondLine }"
              (click)="clearButton()"
              >
              <span class="bpi__icon-close-round"></span>
            </button>
          }
          @if (_value.length === 0) {
            <a #helpDesk [href]="getHelpdeskLink()" [target]="'_blank'" [tabIndex]="-1">
              <span
                [bp-tooltip]="hcArticleTooltipTranslation"
                position="top"
                class="bpi__icon-info form-search-clear-button mod-input-field mod-hover"
                (keydown.enter)="helpDesk.click()"
              [tabIndex]="0"></span>
            </a>
          }
        </span>
      }
      @if (icon && !iconUrl) {
        <i class="form-icon-inside-icon bpi__asset-crypto" [ngClass]="icon"></i>
      }
      @if (iconUrl) {
        <span class="flex form-icon-inside-icon"
          ><img
          [src]="iconUrl"
          class="small-icon"
          (error)="img.src = '/assets/images/default-asset.svg'"
          alt="{{ iconUrlAltText }}"
          #img
        /></span>
      }
      @if (verificationFlowFlag) {
        <span class="bpi__icon-check-circle form-icon-inside-verification"></span>
      }
      @if (textInside) {
        <span class="form-text-inside-text">{{ textInside }}</span>
      }
      @if (showMaxLength(maxlength)) {
        <span class="form-text-inside-counter"
          >{{ _value.length }} / {{ maxlength }}</span
          >
        }
      </div>
    </div>
    @if (error) {
      <span class="form-error" [ngClass]="{ newBpPhoneError: isBpPhone }"
        >>
        {{ error }}
      </span>
    }
    <div #info [hidden]="info?.children?.length === 0" class="bp-input-info">
      <!-- Info Text -->
      <ng-content> </ng-content>
    </div>
  </div>
